import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  Fragment,
} from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import GlobalData from "./GlobalData";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  ColumnMenu,
  Edit,
  Filter,
  Inject,
  Sort,
  RowDD,
} from "@syncfusion/ej2-react-grids";
import { DropDownTreeComponent } from "@syncfusion/ej2-react-dropdowns";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { enableRipple } from "@syncfusion/ej2-base";
import RequirementsEditScreen from "./RequirementsEditScreen";
import RequirementsImportScreen from "./RequirementsImportScreen";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import Button from "@mui/material/Button";
import Tools from "./JNSTools";
import Tour from "./Tour";
import ProjectTitleBar from "./ProjectTitleBar_ably";
import "./styles/Requirements.css";

function RequirementsComponent(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [pageContent, setPageContent] = useState();
  const grid = useRef();
  const originalReqArray = useRef();
  const newReqInitial = {
    name: "",
    synopsis: "",
    stage: "",
    //category: "",
    id: "",
    stageId: "",
    categoryId: "",
    categoryName: "",
    details: "",
  };
  const newReq = useRef(newReqInitial);
  const [openDialog, setOpenDialog] = useState(false);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [dirty, isDirty] = useState(false);
  const [assignmentCopyState, setAssignmentCopyState] = useState(false);
  const approvalMembers = useRef([]);
  const acknowledgementMembers = useRef([]);
  const checkedFromId = useRef();
  const checkedToIds = useRef([]);
  enableRipple(true);
  const categoryDropdownObject = useRef();
  const projectTeam = useRef([]);
  const TOUR_ID = "Requirements";
  let categoryDropdownList = [];
  const initialTourState = {
    key: new Date(),
    run: false,
    loading: false,
    stepIndex: 0,
    steps: [
      {
        target: ".e-icons.e-columnmenu",
        content: (
          <Box>
            <p>Clicking this icon provides column-based features, including:</p>
            <ul>
              <li>Auto fit column</li>
              <li>Sort column in ascending or descending order</li>
              <li>Set column visibility</li>
              <li>Filter column</li>
            </ul>
          </Box>
        ),
        disableBeacon: true,
      },
      {
        target: ".tour-stop-2",
        content: (
          <Box>
            <p>
              Clicking the Synopsis of a requirement will open that
              requirement&apos;s edit screen
            </p>
          </Box>
        ),
      },
      {
        target: ".tour-stop-3",
        content: (
          <Box>
            <p>
              This column shows a checkbox for every person expected to APPROVE
              the requirement. These are set on each individual requirement.
            </p>
          </Box>
        ),
      },
      {
        target: ".tour-stop-4",
        content: (
          <Box>
            <p>
              This column shows a checkbox for every person expected to
              ACKNOWLEDGE the requirement. These are set on each individual
              requirement.
            </p>
          </Box>
        ),
      },
      {
        target: ".tour-stop-5",
        content: (
          <Box>
            <p>Click this button to add a new requirement</p>
          </Box>
        ),
      },
    ],
  };

  //originalReqArray.current = props.reqArray;

  /*if (props.categoryDropdownFields.dataSource) {
    categoryDropdownList = processNodeArray(
      props.categoryDropdownFields.dataSource,
      [],
      "",
    );
    //categoryDropdownList.shift(); // remove 00 option
  }*/

  /*function processNodeArray(nodeArray, outputArray, parentText) {
    if (parentText != "") {
      parentText += ": ";
    }
    for (let x = 0; x < nodeArray.length; x++) {
      outputArray.push({
        name: parentText + nodeArray[x].nodeText,
        id: nodeArray[x].nodeId,
      });
      if (nodeArray[x].nodeChild) {
        outputArray = processNodeArray(
          nodeArray[x].nodeChild,
          outputArray,
          parentText + nodeArray[x].nodeText,
        );
      }
    }
    return outputArray;
  }*/

  const reqApprovalsTemplate = (reqRecord) => {
    return props.reqPersonnelTemplateProcessing(
      reqRecord.oada_req_approvals__c,
      reqRecord.id,
      "reqApprovalsCheckbox",
      "Approvals",
    );
  };

  const reqAcknowledgementsTemplate = (reqRecord) => {
    return props.reqPersonnelTemplateProcessing(
      reqRecord.oada_req_acknowledgements__c,
      reqRecord.id,
      "reqAcknowledgementsCheckbox",
      "Acknowledgements",
    );
  };

  const handleImportOpen = () => {
    setOpenImportDialog(true);
  };

  const handleOpen = (event) => {
    approvalMembers.current = [];
    acknowledgementMembers.current = [];
    projectTeam.current = JSON.parse(JSON.stringify(props.projectTeam));
    let personnelField;
    let membersArray;
    if (event.target.dataset.reqrecord) {
      const reqRecord = JSON.parse(event.target.dataset.reqrecord);
      newReq.current.name = reqRecord.name;
      newReq.current.synopsis = reqRecord.description;
      newReq.current.id = reqRecord.id;
      newReq.current.stageId = reqRecord.issue_stage_id;
      newReq.current.categoryId = reqRecord.oada_req_category__c;
      newReq.current.categoryName = reqRecord.oada_req_category_name__c;
      newReq.current.details = reqRecord.oada_req_details__c;
      newReq.current.previousDetails = reqRecord.oada_req_previous_details__c;
      newReq.current.previousApprovedDetails =
        reqRecord.oada_req_previous_approved_details__c;
      newReq.current.changeLog = reqRecord.oada_issue_change_log__c;

      const stageArray = JSON.parse(
        localStorage.getItem(creds.company + "|IssueStage"),
      );

      newReq.current.stage = stageArray.find(
        (stageElem) => reqRecord.issue_stage_id == stageElem.id,
      ).name;

      // identify approval and acknowledgement members

      for (let i = 0; i < 2; i++) {
        if (i == 0) {
          personnelField = reqRecord.oada_req_approvals__c;
          membersArray = approvalMembers.current;
        } else {
          personnelField = reqRecord.oada_req_acknowledgements__c;
          membersArray = acknowledgementMembers.current;
        }

        /*        const personnelArray = personnelField.match(
          /(".*?"|[^",\s]+)(?=\s*,|\s*$)/g,
        );*/

        const personnelArray = personnelField.match(
          /(".*?"|[^",]+)(?=\s*,|\s*$)/g,
        );

        if (personnelArray) {
          personnelArray.forEach((elem) => {
            const elemString = JSON.stringify(elem);
            const trimmedValue = elemString
              .substring(1, elemString.indexOf("["))
              .trim();

            const userId = elemString.substring(
              elemString.indexOf("[") + 3,
              elemString.indexOf("]"),
            );

            /*const trimmedValueFirstLast =
              trimmedValue.substring(trimmedValue.indexOf("_") + 1) +
              " " +
              trimmedValue.substring(0, trimmedValue.indexOf("_"));*/

            const trimmedValueFirstLast = trimmedValue;

            membersArray.push({
              name: trimmedValueFirstLast,
              id: userId,
            });

            const foundIndex = projectTeam.current.findIndex(
              (memberName) => memberName.name == trimmedValueFirstLast,
            );
            if (foundIndex >= 0) {
              projectTeam.current.splice(foundIndex, 1);
            }
          });
        }
      }
    }
    setOpenDialog(true);
  };

  const handleClose = () => {
    newReq.current = newReqInitial;
    props.waitHandler(false);
    setOpenDialog(false);
  };

  const handleImportClose = (event) => {
    setOpenImportDialog(false);
    if (event.target.textContent == "Close") {
      window.location.reload();
    }
  };

  const copyFromChecked = (event) => {
    if (checkedFromId.current !== undefined) {
      document.getElementById(checkedFromId.current).checked = false;
    }
    if (checkedFromId.current == event.currentTarget.id) {
      checkedFromId.current = undefined;
    } else {
      checkedFromId.current = event.currentTarget.id;
    }
  };

  const copyToChecked = (event) => {
    if (event.currentTarget.checked == true) {
      checkedToIds.current.push(event.currentTarget.id);
    } else {
      const idIndex = checkedToIds.current.findIndex(
        (elem) => elem == event.currentTarget.id,
      );
      if (idIndex !== undefined) {
        checkedToIds.current = checkedToIds.current.splice(idIndex, 1);
      }
    }
  };

  const copyFromTemplate = (reqRecord) => {
    return (
      <div>
        <input
          id={"copyFromCheckbox_" + reqRecord.id}
          type="checkbox"
          onChange={copyFromChecked}
        ></input>
      </div>
    );
  };
  const copyToTemplate = (reqRecord) => {
    return (
      <div>
        <input
          id={"copyToCheckbox_" + reqRecord.id}
          type="checkbox"
          onChange={copyToChecked}
        ></input>
      </div>
    );
  };

  const copyFromHeaderTemplate = () => {
    return (
      <div className="reqTableHeaderHidden">
        <ContentCopyIcon fontSize="small" />
      </div>
    );
  };

  const copyToHeaderTemplate = () => {
    return (
      <div className="reqTableHeaderHidden">
        <ContentPasteIcon fontSize="small" />
      </div>
    );
  };

  const nameTemplate = (reqRecord) => {
    return (
      <div
        onClick={handleOpen}
        data-reqrecord={JSON.stringify(reqRecord)}
        className="reqTableCell"
      >
        {reqRecord.name}
      </div>
    );
  };
  const categoryTemplate = (reqRecord) => {
    return (
      <div
        onClick={handleOpen}
        data-reqrecord={JSON.stringify(reqRecord)}
        className="reqTableCell"
      >
        {reqRecord.oada_req_category_name__c}
      </div>
    );
  };
  const stageTemplate = (reqRecord) => {
    return (
      <div
        onClick={handleOpen}
        data-reqrecord={JSON.stringify(reqRecord)}
        className="reqTableCell"
      >
        {reqRecord.issue_stage}
      </div>
    );
  };
  const synopsisTemplate = (reqRecord) => {
    return (
      <div
        onClick={handleOpen}
        data-reqrecord={JSON.stringify(reqRecord)}
        className="tour-stop-2 reqTableCellEmphasized"
      >
        {reqRecord.description}
      </div>
    );
  };

  const headerTemplate = (reqRecord) => {
    let classNameText = "reqTableHeader";
    if (reqRecord.headerText == "Approvals") {
      classNameText += " tour-stop-3";
    }
    if (reqRecord.headerText == "Acknowledgements") {
      classNameText += " tour-stop-4";
    }
    return <div className={classNameText}>{reqRecord.headerText}</div>;
  };

  const filterSettings = { type: "CheckBox" };

  const handleRowDrop = (event) => {
    let updateRecords = "";
    const newIndex = parseInt(event.dropIndex) + 1;
    if (event.dropIndex > event.fromIndex) {
      updateRecords +=
        '<Modify type="Issue"><Issue><id>' +
        originalReqArray.current[event.fromIndex].id +
        "</id><number>99999999</number></Issue></Modify>";
      for (let i = event.fromIndex; i < event.dropIndex; i++) {
        originalReqArray.current[i + 1].number--;
        updateRecords +=
          '<Modify type="Issue"><Issue><id>' +
          originalReqArray.current[i + 1].id +
          "</id><number>" +
          originalReqArray.current[i + 1].number +
          "</number></Issue></Modify>";
      }
      originalReqArray.current[event.fromIndex].number = newIndex;
      updateRecords +=
        '<Modify type="Issue"><Issue><id>' +
        originalReqArray.current[event.fromIndex].id +
        "</id><number>" +
        newIndex +
        "</number></Issue></Modify>";
    }
    if (event.dropIndex < event.fromIndex) {
      updateRecords +=
        '<Modify type="Issue"><Issue><id>' +
        originalReqArray.current[event.fromIndex].id +
        "</id><number>99999999</number></Issue></Modify>";
      for (let i = event.fromIndex - 1; i >= event.dropIndex; i--) {
        originalReqArray.current[i].number++;
        updateRecords +=
          '<Modify type="Issue"><Issue><id>' +
          originalReqArray.current[i].id +
          "</id><number>" +
          originalReqArray.current[i].number +
          "</number></Issue></Modify>";
      }
      originalReqArray.current[event.fromIndex].number = newIndex;
      updateRecords +=
        '<Modify type="Issue"><Issue><id>' +
        originalReqArray.current[event.fromIndex].id +
        "</id><number>" +
        newIndex +
        "</number></Issue></Modify>";
    }
    originalReqArray.current.sort((a, b) => a.number - b.number);

    //write new numbers to OA

    if (updateRecords.length > 0) {
      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const updateString = authString + updateRecords + "</request>";
      Tools.fetchPost(updateString, urlString);
    }
  };

  function handleCopyOpen() {
    if (
      assignmentCopyState === true &&
      checkedFromId.current !== undefined &&
      checkedToIds.current.length > 0
    ) {
      // execute copy
      props
        .executeCopy(checkedFromId.current, checkedToIds.current)
        .then(() => {
          checkedFromId.current = undefined;
          checkedToIds.current = [];

          setAssignmentCopyState(!assignmentCopyState);
        });
    } else {
      setAssignmentCopyState(!assignmentCopyState);
    }
  }

  useEffect(() => {
    originalReqArray.current = props.reqArray;
    originalReqArray.current.sort((a, b) => a.number - b.number);

    const globalDataObject = new GlobalData(creds);
    //props.waitHandler(true);
    globalDataObject.populateTable("IssueStage").then(() => {
      const stageArray = JSON.parse(
        localStorage.getItem(creds.company + "|IssueStage"),
      );

      const reqArray = [];
      originalReqArray.current.forEach((reqElem) => {
        const stageName = stageArray.find(
          (stageElem) => reqElem.issue_stage_id == stageElem.id,
        ).name;
        reqArray.push({ ...reqElem, issue_stage: stageName });
      });

      const content = (
        <div id="dialog-target">
          <Tour initialState={initialTourState} id={TOUR_ID} />
          <Box>
            <ProjectTitleBar
              aiData={reqArray}
              aiDataType="requirements"
              docPage="REQUIREMENTS TAB.pdf"
              top={48}
            />
            <Box
              sx={{
                width: "100%",
                //overflow: "auto",
                display: "inline-block",
                position: "fixed",
                top: 88,
                backgroundColor: "#aaaaaa",
                zIndex: 1000,
              }}
            >
              <Box justifyContent="space-between" display="flex" border="none">
                <Box>
                  <Button
                    className="tour-stop-5"
                    variant="contained"
                    onClick={handleOpen}
                    sx={{
                      border: "solid 1px",
                      backgroundColor: "darkslategray",
                      borderRadius: "10px",
                      marginBottom: "3px",
                    }}
                  >
                    Add Requirement
                  </Button>
                  <Button
                    className="tour-stop-6"
                    variant="contained"
                    onClick={handleImportOpen}
                    sx={{
                      border: "solid 1px",
                      backgroundColor: "darkslategray",
                      borderRadius: "10px",
                      marginBottom: "3px",
                    }}
                  >
                    Import Requirements
                  </Button>
                </Box>
                <Box>
                  <Button
                    className="tour-stop-7"
                    variant="contained"
                    onClick={handleCopyOpen}
                    sx={{
                      border: "solid 1px",
                      backgroundColor: "darkslategray",
                      borderRadius: "10px",
                      marginBottom: "3px",
                    }}
                  >
                    {assignmentCopyState
                      ? "Execute Copy"
                      : "Enable Team Member Copy"}
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                top: "0px",
                position: "absolute",
              }}
            >
              <GridComponent
                enableStickyHeader={true}
                dataSource={reqArray}
                allowSorting={true}
                showColumnMenu={true}
                allowFiltering={true}
                allowRowDragAndDrop={true}
                rowDrop={handleRowDrop}
                filterSettings={filterSettings}
                ref={(g) => (grid.current = g)}
                cssClass="reqGrid"
                //enablePersistence={true}
              >
                <Inject services={[Sort, ColumnMenu, Filter, Edit, RowDD]} />
                <ColumnsDirective>
                  <ColumnDirective
                    field="name"
                    headerText="Name"
                    textAlign="Left"
                    width="10%"
                    minWidth="100"
                    template={nameTemplate}
                    headerTemplate={headerTemplate}
                    customAttributes={{ class: "reqTableCell" }}
                  />
                  <ColumnDirective
                    field="oada_req_category_name__c"
                    headerText="Category"
                    textAlign="Left"
                    width="16%"
                    minWidth="150"
                    template={categoryTemplate}
                    headerTemplate={headerTemplate}
                    customAttributes={{ class: "reqTableCell" }}
                  />
                  <ColumnDirective
                    field="description"
                    headerText="Synopsis"
                    textAlign="Left"
                    width="35%"
                    minWidth="200"
                    template={synopsisTemplate}
                    headerTemplate={headerTemplate}
                    customAttributes={{ class: "reqTableCell" }}
                  />

                  <ColumnDirective
                    field="issue_stage"
                    headerText="Stage"
                    textAlign="Left"
                    width="11%"
                    minWidth="100"
                    template={stageTemplate}
                    headerTemplate={headerTemplate}
                    customAttributes={{ class: "reqTableCell" }}
                  />
                  {assignmentCopyState ? (
                    <ColumnDirective
                      field="copyFrom"
                      textAlign="Left"
                      //width="2%"
                      width="30"
                      template={copyFromTemplate}
                      headerTemplate={copyFromHeaderTemplate}
                      showColumnMenu={false}
                      showInColumnChooser={false}
                      allowFiltering={false}
                      customAttributes={{ class: "reqTableColumnHidden" }}
                    />
                  ) : null}
                  {assignmentCopyState ? (
                    <ColumnDirective
                      field="copyTo"
                      textAlign="Left"
                      //width="2%"
                      width="30"
                      template={copyToTemplate}
                      headerTemplate={copyToHeaderTemplate}
                      showColumnMenu={false}
                      showInColumnChooser={false}
                      allowFiltering={false}
                      customAttributes={{ class: "reqTableColumnHidden" }}
                    />
                  ) : null}
                  <ColumnDirective
                    field="oada_req_approvals__c"
                    headerText="Approvals"
                    textAlign="Left"
                    width="22%"
                    minWidth="200"
                    template={reqApprovalsTemplate}
                    headerTemplate={headerTemplate}
                    customAttributes={{ class: "reqTableCell" }}
                  />
                  <ColumnDirective
                    field="oada_req_acknowledgements__c"
                    headerText="Acknowledgements"
                    textAlign="Left"
                    width="22%"
                    minWidth="200"
                    template={reqAcknowledgementsTemplate}
                    headerTemplate={headerTemplate}
                    customAttributes={{ class: "reqTableCell" }}
                  />
                </ColumnsDirective>
              </GridComponent>
            </Box>
          </Box>
          <Dialog
            open={openDialog}
            onClose={handleClose}
            //fullWidth={true}
            //maxWidth="md"
            fullScreen
            sx={{ textAlign: "center" }}
          >
            <RequirementsEditScreen
              categoryDropdownFields={props.categoryDropdownFields}
              updateRequirement={props.updateRequirement}
              addRequirement={props.addRequirement}
              deleteRequirement={props.deleteRequirement}
              originalReqArray={originalReqArray}
              handleClose={handleClose}
              newReq={newReq.current}
              projectTeam={projectTeam.current}
              approvalMembers={approvalMembers.current}
              acknowledgementMembers={acknowledgementMembers.current}
              projectObject={projectObject}
            />
          </Dialog>

          <DialogComponent
            cssClass="dialog"
            isModal={true}
            target="#dialog-target"
            visible={openImportDialog}
            close={handleImportClose}
            header="REQUIREMENTS IMPORT"
          >
            <RequirementsImportScreen
              categoryDropdownFields={props.categoryDropdownFields}
              updateRequirement={props.updateRequirement}
              addRequirement={props.addRequirement}
              deleteRequirement={props.deleteRequirement}
              originalReqArray={originalReqArray}
              handleClose={handleImportClose}
              newReq={newReq.current}
              projectTeam={projectTeam.current}
              approvalMembers={approvalMembers.current}
              acknowledgementMembers={acknowledgementMembers.current}
              projectObject={projectObject}
            />
          </DialogComponent>
        </div>
      );
      setPageContent(content);
      if (props.loadCompleted) {
        props.waitHandler(false);
        props.resetLoadCompleted();
      }
    });
  }, [
    props.reqArray,
    originalReqArray.current,
    approvalMembers.current,
    acknowledgementMembers.current,
    dirty,
    openDialog,
    openImportDialog,
    assignmentCopyState,
    //openRequiredFieldNotification,
  ]);

  return pageContent;
}
export default RequirementsComponent;
